export default "__VITE_ASSET__C7VikBsI__"